<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 text-xs-center class="summaryTitle">
        <h1>Elért eredmények</h1>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <v-layout row wrap>
          <!--<v-flex xs6 sm6 text-xs-center justify-center>-->
          <!--  <v-layout row wrap>-->
          <!--    <v-flex xs8 text-xs-right>-->
          <!--      <img-->
          <!--        :src="require('@/assets/img/footprint_mod_1.png')"-->
          <!--        class="summaryImages"-->
          <!--      />-->
          <!--    </v-flex>-->
          <!--    <v-flex xs4 text-xs-left class="result">-->
          <!--      {{ stepCounter }}-->
          <!--    </v-flex>-->
          <!--  </v-layout>-->
          <!--</v-flex>-->

          <!--<v-flex xs6 sm6>-->
          <!--  <v-layout row wrap>-->
          <!--    <v-flex-->
          <!--      xs4-->
          <!--      text-xs-right-->
          <!--      vertical-->
          <!--      align-center-->
          <!--      fill-height-->
          <!--      class="result justify-content-center"-->
          <!--    >-->
          <!--      {{ lingronCounter }} / {{ maxLingron }}-->
          <!--    </v-flex>-->
          <!--    <v-flex xs8 text-xs-left>-->
          <!--      <img-->
          <!--        :src="require('@/assets/img/new_lingron.png')"-->
          <!--        class="summaryImages"-->
          <!--      />-->
          <!--    </v-flex>-->
          <!--  </v-layout>-->
          <!--</v-flex>-->

          <v-flex xs12 sm12 text-xs-center justify-center>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-chip
                  class="pa-2 mt-3 summaryPoints margin-y"
                  color="#F9F871"
                >
                  +{{ (stepCounter + lingronCounter) * multiplier }} pont
                </v-chip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- <v-flex xs12 text-xs-center>
            <h2>Gratulálunk szereztél egy csillagot!</h2>
        </v-flex> -->

      <v-flex xs12 text-xs-center>
        <img
          :src="require('@/assets/img/star_shadow_1.png')"
          class="summaryImages"
        />
      </v-flex>

      <v-flex xs12 text-xs-center class="summaryTitle pb-1">
        <h2 v-if="sentences.length > 2">Megtanult mondatok</h2>
        <h2 v-else>Gratulálunk!</h2>

        <v-layout row wrap>
          <v-flex
            xs12
            md10
            offset-md1
            v-for="(sentence, index) in sentences"
            v-bind:key="index"
            class="summarySentences p-3"
          >
            <transition name="fadeSlow">
              <!-- <v-card v-bind:color="sentence.color" dark v-show="sentence.show"> -->
              <v-card color="#357ee8" dark v-show="sentence.show" class="p-2">
                {{ sentence.sentence }}
              </v-card>
            </transition>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-spacer></v-spacer>

      <v-flex xs12 class="mt-2 align-self-center text-center">
        <v-divider></v-divider>

        <v-layout row wrap class="bgPurple">
          <v-flex xs12>
            <v-btn large dark flat @click="$router.push({ name: 'home' })">
              Leckékhez
              <v-icon right dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="tipp.show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            Lecke teljesítve!

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="tipp.show = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="tipp.show = false">
            <p>
              Ne állj meg most! <br />
              Menj vissza és gyakorolj újra! <br />
              Az ismétléseknek köszönhetően automatikusan fogsz megtanulni
              minden szót!
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="tipp.show = false">
                  Bezár
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      // lessonId: this.$route.params.lessonId,
      lessonId: this.$store.getters.currentLessonId,
      stepCounter: this.$store.getters.getStepCounter,
      lingronCounter: this.$store.getters.getLingronCounter,
      maxLingron: this.$store.getters.getMaxLingron,
      sentences: "",
      multiplier: 1,
      tipp: {
        show: false
      }
    };
  },
  methods: {
    getSummaryData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/summary", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
          userId: this.$store.getters.currentUser.id,
          stepCounter: this.$data.stepCounter,
          lingronCounter: this.$data.lingronCounter
        })
        .then(response => {
          // console.log('Summary - resp: ', response.data);

          this.$data.sentences = response.data.sentences;
          this.$data.multiplier = response.data.multiplier;

          //Show the "let's go, just do it thing" modal :-)
          // if( response.data.subscription.package_id === 7 && this.$data.lessonId <= 13 )
          // {
          //     this.$data.tipp.show = true;
          // }
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("summary - error: ", error);
          }
        });
    },
    setColor(index) {
      if (index === 0) {
        return "red";
      }

      if (index === 1) {
        return "blue";
      }

      if (index === 2) {
        return "green";
      }

      if (index === 3) {
        return "yellow";
      }
    }
  },
  created: function() {
    this.getSummaryData();
  }
};
</script>
